var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-end gap-4"},[(_vm.pendingMatch)?_c('m-pending-match-card',{attrs:{"value":_vm.pendingMatch},on:{"onStateChanged":_vm.nextMatch}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }